'use strict';

export const CHAT_MESSAGE_LIST_NAME = 'chatMessages';
export const CHAT_MESSAGE_LIST_PREFIX = `@@${CHAT_MESSAGE_LIST_NAME}`;

export const CHAT_MODAL_LIST_NAME = 'chatModal';
export const CHAT_MODAL_LIST_PREFIX = `@@${CHAT_MODAL_LIST_NAME}`;

export const CHAT_SUBSCRIBERS_LIST_NAME = 'chatSubscribers';
export const CHAT_SUBSCRIBERS_LIST_PREFIX = `@@${CHAT_SUBSCRIBERS_LIST_NAME}`;

export const USER_SUBSCRIPTIONS_LIST_NAME = 'userSubscriptions';
export const USER_SUBSCRIPTIONS_LIST_PREFIX = `@@${USER_SUBSCRIPTIONS_LIST_NAME}`;

export const VIDEO_CHAT_START_NAME = 'videoChatStartModal';
export const VIDEO_CHAT_START_PREFIX = `@@${VIDEO_CHAT_START_NAME}`;

export const VIDEO_SESSION_NAME = 'videoSession';
export const VIDEO_SESSION_PREFIX = `@@${VIDEO_SESSION_NAME}`;



// WEBPACK FOOTER //
// ./src/js/comments/redux/state.js